"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactRouterDom = require("react-router-dom");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledNav = _styledComponents.default.nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: 2;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  align-items: space-between;\n  justify-content: space-between;\n  pointer-events: none;\n  background: ", ";\n  box-shadow: ", ";\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    margin: 0 auto;\n    transform: translateX(-50%);\n  }\n"])), function (p) {
  return p.position || "fixed";
}, function (p) {
  return p.background || p.theme.colorNavbarBackground;
}, function (p) {
  return p.theme.boxShadowNavbar || "none";
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.theme.railWidth;
});

var sharedLinkCss = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 50%;\n  display: flex;\n  height: 80px;\n  padding-top: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  text-align: center;\n  transition: transform 0.25s;\n  pointer-events: all;\n  text-decoration: none;\n  color: ", ";\n"])), function (p) {
  return p.color || p.theme.colorNavbarLink;
});
var StyledNavLink = (0, _styledComponents.default)(_reactRouterDom.NavLink)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  &.active {\n    color: ", ";\n  }\n"])), sharedLinkCss, function (p) {
  return p.colorActive || p.theme.colorNavbarLinkActive;
});

var StyledDisabledLink = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: not-allowed;\n  color: ", ";\n"])), sharedLinkCss, function (p) {
  return p.theme.colorNavbarLinkDisabled || (0, _polished.rgba)("black", 0.15);
});

var StyledNavLinkIcon = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0.325rem;\n"])));

var StyledNavLinkText = _styledComponents.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 0.675rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var StyledBadge = _styledComponents.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  margin-left: -7px;\n  width: 14px;\n  height: 14px;\n  transform: translateX(0);\n  border-radius: 50%;\n  border: solid 2px ", ";\n  background: ", ";\n"])), function (p) {
  return p.background || p.theme.colorNavbarBackground;
}, function (p) {
  return p.theme.colorNavbarLinkActive;
});

var StyledBadgeSvg = _styledComponents.default.svg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n"])));

var StyledBadgeCircle = _styledComponents.default.circle(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (p) {
  return p.theme.colorNavbarLinkActive;
});

var BadgeSvg = function BadgeSvg() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBadgeSvg, {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBadgeCircle, {
      cx: "5",
      cy: "5",
      r: "5"
    })
  });
};

var NavbarSimple = function NavbarSimple(_ref) {
  var items = _ref.items,
      position = _ref.position,
      navbarWidth = _ref.navbarWidth;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNav, {
    position: position,
    navbarWidth: navbarWidth,
    children: items.map(function (item) {
      return item.disabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDisabledLink, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkIcon, {
          className: "material-icons",
          children: item.icon
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkText, {
          children: item.text
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledNavLink, {
        to: item.to,
        exact: item.exact,
        children: [item.showBadge && /*#__PURE__*/(0, _jsxRuntime.jsx)(BadgeSvg, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkIcon, {
          className: "material-icons",
          children: item.icon
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkText, {
          children: item.text
        })]
      });
    })
  });
};

var _default = NavbarSimple;
exports.default = _default;